import React from 'react';
import { TextField, Styles } from 'material-ui';
import FileSelectorDialog from 'components/Widgets/FileSelectorDialog';
import DropZone from 'components/DropZone';
import { FormattedMessage } from 'react-intl';
import CircularProgress from 'components/Material/CircularProgress';
import * as Icons from 'components/Material/SvgIcons';
import PageModule from 'components/PageModule';
import styles from 'components/Page/Module/Styles';
import Message from 'services/Message';

const { Spacing } = Styles;

const donwloadStyles = {
  root: {
    textAlign: 'center'
  }
};

class DownloadModule extends PageModule {
  static readable = 'DownloadModule';

  constructor() {
    super(...arguments);
    const { content, params } = this.props;
    const { caption } = params;
    const files = content || [];

    this.state = {
      edit: {
        files,
        caption
      }
    };
  }

  selectMedia(file) {
    const edit = {
      fileId: file.id,
      ...this.state.edit,
      files: [
        {
          ...file
        }
      ]
    };

    this.setState({ edit, fileSelectorOpen: false });
    if (edit.files && edit.files[0].type) {
      this.attach(edit);
      this.autoSave();
    } else {
      this.autoSave();
    }
  }

  attach(data) {
    if (data.length && data.length > 0) {
      const file = data[0].file;
      const files = [file];
      const edit = {
        ...this.state.edit,
        fileId: file.id,
        fileName: file.name,
        files
      };
      this.setState({ edit });
      this.autoSave();
    }
  }

  progress(event) {
    this.setState({ progress: event.percent });
  }

  onMediaLibrary() {
    this.setState({ fileSelectorOpen: true });
  }

  onMediaLibraryClose() {
    this.setState({ fileSelectorOpen: false });
  }

  openDownload(event) {
    this.refs.dropZone.open();
    event.stopPropagation();
    event.preventDefault();
  }

  changeCaption(e) {
    if (this._timer) {
      clearTimeout(this._timer);
    }
    const edit = {
      ...this.state.edit,
      caption: e.target.value
    };
    this.setState({ edit });
    this._timer = setTimeout(() => {
      this.autoSave();
      Message.info(this.context.getIntlMessage('video.changesSaved'));
      this._timer = null;
    }, 1000);
  }

  getModuleData(content, data) {
    return {
      caption: this.state.edit.caption,
      fileId: this.state.edit.fileId || data.fileId,
      external: this.state.edit.external
    };
  }

  getPrettySize(size) {
    let unit;
    let prettySize;
    if (size < 1024) {
      prettySize = size;
      unit = 'B';
    } else if (size < 1048576) {
      prettySize = size / 1024;
      unit = 'KB';
    } else if (size < 1073741824) {
      prettySize = size / 1048576;
      unit = 'MB';
    } else {
      prettySize = size / 1073741824;
      unit = 'GB';
    }
    prettySize = Math.round(prettySize * 100) / 100;
    return prettySize + ' ' + unit;
  }

  getModuleData(content, data) {
    return {
      caption: this.state.edit.caption,
      fileId: this.state.edit.fileId || data.fileId
    };
  }

  changeLink(file, e) {
    this.props.gaTracking();
    if (
      (file.type && file.type.indexOf('video') != -1) ||
      (file.type && file.type.indexOf('audio') != -1)
    ) {
      e.stopPropagation();
      e.preventDefault();

      let parts = file.url.split('?'),
        //    r = new Image,
        url =
          document.location.protocol +
          parts[0]
            .replace(/,/g, '.')
            .replace(
              'coursio.s3-eu-west-1.amazonaws.com',
              'download.s.coursio.com'
            );

      // console.log('start', url)

      let r = document.createElement('iframe');

      r.onload = function(e, a, b, c) {
        // console.log(e,a,b,c)

        let parts2 = url.split('.');

        if (['ogg', 'mp4'].indexOf(parts2.slice(-1)[0]) != -1) {
          parts2.pop();
          url = parts2.join('.');
        } else {
          url = parts2 + '.mp4';
        }

        if (parts.length > 1) {
          url += '?' + parts[1];
        }

        url = url.replace(/,/g, '.');
        // console.log('fixed url', url)
        window.open(url, '_blank');
      };

      r.onerror = function() {
        // console.log('nothing done', url)
        url += '?name=' + file.name;
        // console.log(url)
        window.open(url.replace(/,/g, '.'), '_blank');
      };

      r.src = url + '?name=' + file.name;
      document.body.appendChild(r);

      return false;
    }
  }

  renderDetailMode() {
    let files = [];
    const { edit } = this.state;

    if (edit.files.length > 0) {
      files = edit.files.map((file, index) => {
        return (
          <a
            onClick={this.changeLink.bind(this, file)}
            key={index}
            download
            href={
              file.url.replace(
                'coursio.s3-eu-west-1.amazonaws.com',
                'download.s.coursio.com'
              ) +
              '?name=' +
              file.name.toLowerCase().replace('&', 'and')
            }
            style={{ lineHeight: `${Spacing.desktopKeylineIncrement}px` }}
          >
            <Icons.FileCloudDownload
              style={styles.icon}
              color={this.props.themeColor}
            />
            {file.name}({this.getPrettySize(file.size)})
          </a>
        );
      });
    } else {
      files = (
        <div style={styles.dropZone}>
          <div style={styles.moduleContainer}>
            <Icons.FileCloudDownload style={styles.icon} />
            <br />
            {this.context.getIntlMessage('module.uploadFile')}
          </div>
        </div>
      );
    }

    return (
      <div style={donwloadStyles.root}>
        {files}
        <figcaption>{edit.caption}</figcaption>
      </div>
    );
  }

  renderEditMode() {
    const { fileSelectorOpen, edit } = this.state;

    const uploadLink = (
      <a onTouchTap={::this.openDownload}>
        {this.context.getIntlMessage('module.upload')}
      </a>
    );
    const libraryLink = (
      <a onTouchTap={::this.onMediaLibrary}>
        {this.context.getIntlMessage('module.library')}
      </a>
    );
    let download;

    if (this.state.progress > 0 && this.state.progress < 100) {
      download = (
        <CircularProgress
          progressColor={this.context.muiTheme.rawTheme.palette.primary1Color}
          progress={this.state.progress}
          size={2}
        />
      );
    } else if (edit.files.length > 0) {
      download = edit.files.map((file, index) => {
        return (
          <a
            key={index}
            target="_blank"
            href={file.url}
            style={{ lineHeight: `${Spacing.desktopKeylineIncrement}px` }}
          >
            <Icons.FileCloudDownload style={styles.icon} />
            {file.name} ({this.getPrettySize(file.size)})
          </a>
        );
      });
    } else {
      download = <Icons.FileCloudDownload style={styles.icon} />;
    }

    return (
      <div>
        <DropZone
          ref="dropZone"
          style={styles.dropZone}
          lineHeight={Spacing.desktopKeylineIncrement / 2}
          onProgress={::this.progress}
          onSuccess={::this.attach}
        >
          <div style={styles.moduleContainer}>{download}</div>
          <div style={styles.header}>
            {this.context.getIntlMessage('module.dropOneFile')}
          </div>
          <div style={styles.subHeader}>
            <FormattedMessage
              message={this.context.getIntlMessage('module.uploadOrBrowse')}
              upload={uploadLink}
              library={libraryLink}
            />
          </div>
          <TextField
            fullWidth
            floatingLabelText={this.context.getIntlMessage('Caption')}
            value={edit.caption}
            onChange={::this.changeCaption}
          />
        </DropZone>
        <FileSelectorDialog
          open={fileSelectorOpen}
          onSelect={::this.selectMedia}
          onClose={::this.onMediaLibraryClose}
        />
      </div>
    );
  }
}

export default DownloadModule;



// WEBPACK FOOTER //
// ./src/js/components/Page/Module/Download.js